import type { Monaco } from "@monaco-editor/react";
import type { editor } from "monaco-editor";
import GitHubDarkTheme from "../themes/gh-dark.json";
import GitHubTheme from "../themes/gh.json";

let isMonacoInitialized = false;

/**
 * Global Monaco Editor initialization - should be called once per app lifecycle
 * This sets up themes and other global Monaco configuration to avoid conflicts
 * between multiple editor instances.
 */
export function initializeMonaco(monaco: Monaco): void {
  if (isMonacoInitialized) {
    return;
  }

  // Define themes globally once
  monaco.editor.defineTheme("gh", GitHubTheme as editor.IStandaloneThemeData);
  monaco.editor.defineTheme(
    "gh-dark",
    GitHubDarkTheme as editor.IStandaloneThemeData
  );

  isMonacoInitialized = true;
}

/**
 * Safe theme setter that only sets the theme without trying to define it
 */
export function setMonacoTheme(monaco: Monaco, isDark: boolean): void {
  const themeName = isDark ? "gh-dark" : "gh";
  monaco.editor.setTheme(themeName);
}
